import { useCallback, useEffect, useState } from "react";
import { useOnUpdateUserEvents } from "../../../hooks/firestoreHooks/eventListUpdateHook";
import { useAppDispatch } from "../../../hooks/storeHooks";
import { getEventHistoryThunk } from "../../../store/events/eventThunk";
import { EVENT_TYPE_HISTORY } from "../../../types/eventTypes";
import EventGrid from "../EventGrid";
import { ROUTE_QUERY_CONSTANTS } from "../../../routes";

const Declined = () => {
  const dispatch = useAppDispatch();
  const [shouldStartUpdating, setShouldStartUpdating] = useState(false);

  const fetchEventListData = useCallback(async () => {
    dispatch(
      getEventHistoryThunk({
        type: EVENT_TYPE_HISTORY.DECLINED,
        isLoading: false,
      })
    );
  }, [dispatch]);

  useOnUpdateUserEvents(shouldStartUpdating, fetchEventListData);

  useEffect(() => {
    const getData = async () => {
      dispatch(
        getEventHistoryThunk({
          type: EVENT_TYPE_HISTORY.DECLINED,
          isLoading: true,
        })
      );
      setShouldStartUpdating(true);
    };
    getData();
  }, []);

  return (
    <EventGrid
      gridId={`EVENT_DECLINED`}
      isDeclinedGrid
      eventType={ROUTE_QUERY_CONSTANTS.Declined}
      showSave={false}
      title={"Declined Events"}
      queryParams={ROUTE_QUERY_CONSTANTS.Declined}
    />
  );
};

export default Declined;
